export class Currency {
    constructor(bcCurrency) {
        this.isoCode = bcCurrency.country_iso2;
        this.currencyCode = bcCurrency.currency_code;
        this.symbol = bcCurrency.token;
        this.symbolPosition =
            bcCurrency.token_location === "right"
                ? CurrencySymbolPosition.Right
                : CurrencySymbolPosition.Left;
        this.decimalToken = bcCurrency.decimal_token;
        this.thousandsToken = bcCurrency.thousands_token;
        this.decimalPlaces = bcCurrency.decimal_places;
    }
}
export var CurrencySymbolPosition;
(function (CurrencySymbolPosition) {
    CurrencySymbolPosition[CurrencySymbolPosition["Left"] = 0] = "Left";
    CurrencySymbolPosition[CurrencySymbolPosition["Right"] = 1] = "Right";
})(CurrencySymbolPosition || (CurrencySymbolPosition = {}));
